import {defineStore} from 'pinia';
import axios from "axios";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {setUrlParam} from "@/baseUtils";
import i18n from "@/i18n";

export const mainSearchStore = defineStore('mainSearchStore',{
    state: () => ({
        searchParams: {
            searchString: '',
            searchType: 'ALL',
            searchOrder: 'CREATED',
            searchMode: 'IDENTITY',
            page: 0,
            size: 10,
            lastPage: false
        },
        searchAllResult: [
             {
                type: 'PROPOSAL',
                state: false,
                result: []
            },
            {
                type: 'OPINION',
                state: false,
                result: []
            },
            {
                type: 'ARGUMENT',
                state: false,
                result: []
            },
            {
                type: 'MEMBER',
                state: false,
                result: []
            },
            {
                type: 'ORGANIZATION',
                state: false,
                result: []
            },
            {
                type: 'FORUM',
                state: false,
                result: []
            },
            {
                type: 'SOURCE',
                state: false,
                result: []
            }
        ],
        searchResultProposalAll: [
            {
                type: 'IDENTITY',
                state: false,
                result: []
            },
            {
                type: 'CREATOR',
                state: false,
                result: []
            },
            {
                type: 'SUBJECTS',
                state: false,
                result: []
            }
        ],
        searchResultOpinionAll: [
            {
                type: 'IDENTITY',
                state: false,
                result: []
            },
            {
                type: 'CREATOR',
                state: false,
                result: []
            }
        ],
        searchResultArgumentAll: [
            {
                type: 'IDENTITY',
                state: false,
                result: []
            },
            {
                type: 'CREATOR',
                state: false,
                result: []
            }
        ],
        searchResult: [],
        searchResultInfoModalState: false,
        searchResultInfoModalCallback: null
    }),
    getters: {
        hasSearchParamControls() {
            return this.searchParams.searchType === 'PROPOSAL'
                || this.searchParams.searchType === 'OPINION'
                || this.searchParams.searchType === 'ARGUMENT';
        },
        multipleSearch() {
            return this.searchParams.searchMode === 'ALL';
        },
        searchByOptions() {
            let options = [];

            if (this.searchParams.searchType === 'PROPOSAL') {
                options = [
                    { name: i18n.global.t('mainSearch.searchByFilter.all'), code: 'ALL' },
                    { name: i18n.global.t('mainSearch.searchByFilter.title'), code: 'IDENTITY' },
                    { name: i18n.global.t('mainSearch.searchByFilter.creator'), code: 'CREATOR' },
                    { name: i18n.global.t('mainSearch.searchByFilter.subjects'), code: 'SUBJECTS' },
                ]
            } else {
                options = [
                    { name: i18n.global.t('mainSearch.searchByFilter.all'), code: 'ALL' },
                    { name: i18n.global.t('mainSearch.searchByFilter.title'), code: 'IDENTITY' },
                    { name: i18n.global.t('mainSearch.searchByFilter.creator'), code: 'CREATOR' },
                ]
            }

            return options;
        }
    },
    actions: {
        runSearch(resetSearch, showLoader) {
            const type = this.searchParams.searchType;
            let searchProcess = [];

            if (this.searchParams.searchString.length < 3) {
                this.searchResult = [];
                return Promise.resolve();
            }

            if (resetSearch) {
                this.resetSearch();
            }

            if (showLoader) {
                baseLoaderStore().showBaseLoader();
            }

            if (type === 'ALL') {
                this.getProposalsAction({
                    text: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('PROPOSAL', resp);
                });

                this.getOpinionsAction({
                    text: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('OPINION', resp);
                });

                this.getArgumentsAction({
                    text: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('ARGUMENT', resp);
                });

                this.getMembersAction({
                    text: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('MEMBER', resp);
                });

                this.getOrganizationsAction({
                    text: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('ORGANIZATION', resp);
                });

                this.getForumsAction({
                    title: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('FORUM', resp);
                });

                this.getSourceReferencesAction({
                    sourceText: this.searchParams.searchString,
                    page: this.searchParams.page,
                    size: 4,
                }).then((resp)=> {
                    this.processSearchAllResultResponse('SOURCE', resp);
                });
            } else if (type === 'PROPOSAL') {
                if (this.multipleSearch) {
                    this.getProposalsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'IDENTITY',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultProposalAll.find(list => list.type === "IDENTITY");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });

                    this.getProposalsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'CREATOR',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultProposalAll.find(list => list.type === "CREATOR");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });

                    this.getProposalsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'SUBJECTS',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultProposalAll.find(list => list.type === "SUBJECTS");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });
                } else {
                    searchProcess.push(
                        this.getProposalsAction({
                            text: this.searchParams.searchString,
                            statuses: 'CURRENT',
                            page: this.searchParams.page,
                            size: this.searchParams.size,
                            mode: this.searchParams.searchMode,
                            order: this.searchParams.searchOrder,
                        }).then((resp)=> {
                            this.processSearchResultResponse(resp);
                        })
                    );
                }
            } else if (type === 'OPINION') {
                if (this.multipleSearch) {
                    this.getOpinionsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'IDENTITY',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultOpinionAll.find(list => list.type === "IDENTITY");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });

                    this.getOpinionsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'CREATOR',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultOpinionAll.find(list => list.type === "CREATOR");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });
                } else {
                    searchProcess.push(
                        this.getOpinionsAction({
                            text: this.searchParams.searchString,
                            page: this.searchParams.page,
                            size: this.searchParams.size,
                            mode: this.searchParams.searchMode,
                            order: this.searchParams.searchOrder,
                        }).then((resp)=> {
                            this.processSearchResultResponse(resp);
                        })
                    );
                }
            } else if (type === 'ARGUMENT') {
                if (this.multipleSearch) {
                    this.getArgumentsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'IDENTITY',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultArgumentAll.find(list => list.type === "IDENTITY");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });

                    this.getArgumentsAction({
                        text: this.searchParams.searchString,
                        statuses: 'CURRENT',
                        mode: 'CREATOR',
                        page: 1,
                        size: 4,
                    }).then((resp)=> {
                        const activeList = this.searchResultArgumentAll.find(list => list.type === "CREATOR");
                        activeList.result = resp.data.content.slice(0, 3);
                        activeList.state = true;
                        activeList.showAllState = resp.data.content.length > 3;
                    });
                } else {
                    searchProcess.push(
                        this.getArgumentsAction({
                            text: this.searchParams.searchString,
                            page: this.searchParams.page,
                            size: this.searchParams.size,
                            mode: this.searchParams.searchMode,
                            order: this.searchParams.searchOrder,
                        }).then((resp)=> {
                            this.processSearchResultResponse(resp);
                        })
                    );
                }
            } else if (type === 'MEMBER') {
                searchProcess.push(
                    this.getMembersAction({
                        text: this.searchParams.searchString,
                        page: this.searchParams.page,
                        size: this.searchParams.size,
                    }).then((resp)=> {
                        this.processSearchResultResponse(resp);
                    })
                );
            } else if (type === 'ORGANIZATION') {
                searchProcess.push(
                    this.getOrganizationsAction({
                        text: this.searchParams.searchString,
                        page: this.searchParams.page,
                        size: this.searchParams.size,
                    }).then((resp)=> {
                        this.processSearchResultResponse(resp);
                    })
                );
            } else if (type === 'FORUM') {
                searchProcess.push(
                    this.getForumsAction({
                        title: this.searchParams.searchString,
                        page: this.searchParams.page,
                        size: this.searchParams.size,
                    }).then((resp)=> {
                        this.processSearchResultResponse(resp);
                    })
                );
            } else if (type === 'SOURCE') {
                searchProcess.push(
                    this.getSourceReferencesAction({
                        sourceText: this.searchParams.searchString,
                        page: this.searchParams.page,
                        size: this.searchParams.size,
                    }).then((resp)=> {
                        this.processSearchResultResponse(resp);
                    })
                );
            }

             return Promise.all(searchProcess).then(()=> {
                 baseLoaderStore().hideBaseLoader();
            });
        },
        processSearchAllResultResponse(type, resp) {
            const activeList = this.searchAllResult.find(list => list.type === type);

            activeList.result = resp.data.content.slice(0, 3);
            activeList.state = true;
            activeList.showAllState = resp.data.content.length > 3;
        },
        processSearchResultResponse(resp) {
            const newItems = resp.data.content;

            this.searchResult = newItems.length > 0 ? this.searchResult.concat(resp.data.content) : newItems;
            this.searchParams.last = resp.data.numberOfElements < this.searchParams.size;
        },
        resetSearch() {
            this.searchParams.page = 0;
            this.searchParams.size = 10;
            this.searchParams.lastPage = false;
            this.searchResult = [];
        },
        updateSearchParams(option, val) {
            this.searchParams[option] = val;
        },
        updateSearchUrl() {
            const searchString = this.searchParams.searchString;
            const searchType = this.searchParams.searchType;

            setUrlParam('q', searchString);
            setUrlParam('type', searchType);
        },
        getProposalsAction(params) {
            return axios.get('/api/proposals', {params: params});
        },
        getOpinionsAction(params) {
            return axios.get('/api/opinions', {params: params});
        },
        getArgumentsAction(params) {
            return axios.get('/api/arguments', {params: params});
        },
        getMembersAction(params) {
            return axios.get('/api/user/accounts', {params: params});
        },
        getOrganizationsAction(params) {
            return axios.get('/api/organizations', {params: params});
        },
        getForumsAction(params) {
            return axios.get('/api/forums', {params: params});
        },
        getSourceReferencesAction(params) {
            return axios.get('/api/source/references', {params: params});
        },
        openSearchResultInfoModal(callback) {
            this.searchResultInfoModalState = true;
            if (callback) {
                this.searchResultInfoModalCallback = callback;
            }
        },
        closeSearchResultInfoModal() {
            this.searchResultInfoModalState = false;
            if (this.searchResultInfoModalCallback) {
                this.searchResultInfoModalCallback();
            }
        },
    }
})